import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import SiteFooter from "./components/SiteFooter";
import Zeri from "./components/zeri/Zeri";
import ZeriZhuanye from "./components/zeri/Zeri_zhuanye";
import ZeriMobile from "./components/zeri/Zeri_m";

function App_zeri() {
  const [currentView, setCurrentView] = useState("zeri");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  React.useEffect(() => {
    const token = localStorage.getItem("access_token");
    setIsLoggedIn(!!token);

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setIsLoggedIn(false);
  };

  const PCLayout = ({ children }) => (
    <>
      <Navbar currentView={currentView} setCurrentView={setCurrentView} />
      <div className="flex-grow w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </div>
      <SiteFooter />
    </>
  );

  return (
    <HelmetProvider>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <main className="flex-grow">
          <Routes>
            <Route 
              path="/index" 
              element={isMobile ? <ZeriMobile /> : <PCLayout><Zeri /></PCLayout>} 
            /> 
            <Route path="/mobile" element={<ZeriMobile />} />
            <Route path="/zeri_zhuanye" element={<ZeriZhuanye />} />   
            <Route path="*" element={<Navigate to="/index" replace />} />
          </Routes>
        </main>
      </div>
    </HelmetProvider>
  );
}

export default App_zeri;